import { Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { VotingSessionProvider } from "./providers/votingSession/VotingSessionProvider";
import { VoteScreen } from "./screens/vote/VoteScreen";
import { FullPageLoader } from "~/components/FullPageLoader";
import { ScreenWrapper } from "~/components/ScreenWrapper";
import { EventStoreProvider } from "~/providers/eventStore/EventStoreProvider";
import { ErrorScreen } from "~/screens/ErrorScreen";

export default function App() {
  return (
    <Suspense fallback={<FullPageLoader />}>
      <EventStoreProvider>
        <VotingSessionProvider>
          <ScreenWrapper>
            <ErrorBoundary FallbackComponent={ErrorScreen}>
              <VoteScreen />
            </ErrorBoundary>
          </ScreenWrapper>
        </VotingSessionProvider>
      </EventStoreProvider>
    </Suspense>
  );
}
